export default __webpack_public_path__ + "static/media/_DSC0225.233dd1af.JPG";